import * as Yup from "yup";

const productAddForSell = Yup.object().shape({
	productId: Yup.string().required("Choose a product."),
	quantity: Yup.number()
		.min(1, "Quantity should be at least 1.")
		.required("Quantity is required."),
	rate: Yup.number()
		.min(1, "Rate should be at least 1.")
		.required("Rate is required."),
});

export default productAddForSell;
